import React, { useState, useRef } from "react";
import { POST, GET, newFetch } from "../../../helpers/fetch";
import moment from "moment";
import Logo from "../../../components/Logo";
import ManpowerLogo from "../../../assets/images/logos/MAN_BE_Logo_SS_STK_MC_RGB.png";
import Modal from "react-modal";
import { CloseButton } from "@mantine/core";
import Swal from "sweetalert2";

const FaceVerification = ({
  type,
  imgSrc,
  src,
  videoRef,
  faceapi,
  showModalFaceVerification,
  setShowModalFaceVerification,
  checkMySchedule,
  faceVerificationInterval,
  setFaceVerificationInterval,
  cancelButtonRef,
  message,
  setMessage,
  t,
  siteId,
  fetchSourceImage,
}) => {
  const canvasRef = useRef();
  const count = useRef(0);
  const showSquare = useRef(false);
  const videoHeight = 290;
  const videoWidth = 400;
  const [initializing, setInitializing] = useState(true);
  const [counter, setCounter] = useState(0);

  let height2 = 345;
  let heightPx2 = height2 + "px";
  let heightOffset2 = height2 / 2;
  let offsetPx2 = heightOffset2 + "px";

  const style2 = {
    border: "0",
    borderRadius: "0px",
    bottom: "auto",
    height: "600px", // set height
    left: "50%",
    padding: "2rem 0 0 0",
    position: "fixed",
    right: "auto",
    top: "30%", // start from center
    transform: "translate(-50%,-" + offsetPx2 + ")", // adjust top "up" based on height
    width: "90%",
    overflow: "hidden",
    maxWidth: "900px",
  };

  const errorToast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
  });

  const handleCloseModalFaceVerification = async () => {
    setMessage(t("initializing"));
    setInitializing(true);
    await clearInterval(faceVerificationInterval);
    await setShowModalFaceVerification(false);
    if (videoRef.current?.srcObject == null) {
      await src.getVideoTracks().forEach((track) => {
        track.stop();
        src.removeTrack(track);
      });
    } else {
      await videoRef.current.srcObject.getVideoTracks().forEach((track) => {
        track.stop();
        videoRef.current.srcObject.removeTrack(track);
      });
      //video.srcObject.getTracks()[0].stop();
    }
  };

  const checkNewLandmarks = async (site_id) => {
    const api_path = `/external/site/${site_id}/check_new_landmarks`;
    const response = await newFetch(GET, api_path);
    if (response !== undefined && response.success) {
      let data = response.data;
      const details = JSON.parse(sessionStorage.getItem("faceApp"));
      if (
        moment(data.updatedAt)
          .subtract(8, "hours")
          .isSameOrAfter(moment(details.up_time))
      ) {
        fetchSourceImage(site_id);
      }
    }
  };

  const captureSnapshot = async (associate_id) => {
    if (canvasRef.current != null) {
      let ctx = canvasRef.current.getContext("2d");
      ctx.drawImage(videoRef.current, 0, 0, videoWidth, videoHeight);
      let snapshot = canvasRef.current.toDataURL("image/jpeg");
      let api_path = `/external/associate/${associate_id}/save_verified_img`;
      let response = await newFetch(POST, api_path, { snapshot, type });
    }
  };

  const handleVideoOnPlay = () => {
    let cntDetection = 0;
    let cntCanvasRef = 0;
    let flag = false;
    count.current = 0;
    let verifyFace = setInterval(async () => {
      if (initializing) {
        setInitializing(false);
      }
      canvasRef.current.innerHTML = faceapi.createCanvasFromMedia(
        videoRef.current
      );
      const displaySize = {
        width: videoWidth,
        height: videoHeight,
      };

      let glower = document.getElementById("video-container");
      const descriptionsImg = [];
      if (imgSrc) {
        if (canvasRef.current != null) {
          faceapi.matchDimensions(canvasRef.current, displaySize);

          const detections = await faceapi
            .detectSingleFace(
              videoRef.current,
              new faceapi.TinyFaceDetectorOptions({
                inputSize: 224,
                scoreThreshold: 0.7,
              })
              //new faceapi.SsdMobilenetv1Options({minConfidence: 0.95, maxResults: 1})
            )
            .withFaceLandmarks()
            .withFaceDescriptor();

          cntCanvasRef++;

          if (cntCanvasRef > 4 && cntCanvasRef < 8) {
            setMessage(t("move_closer"));
          }

          // means face has been detected
          if (
            detections &&
            showModalFaceVerification == true &&
            cancelButtonRef.current
          ) {
            cntCanvasRef = 8;
            cntDetection++;
            showSquare.current = true;
            descriptionsImg.push(detections.descriptor);
            const labeledDescriptors = [
              new faceapi.LabeledFaceDescriptors("Verified", descriptionsImg),
            ];
            const faceMatcher = new faceapi.FaceMatcher(
              labeledDescriptors,
              0.36
            );

            const resizedDetections = faceapi.resizeResults(
              detections,
              displaySize
            );

            if (canvasRef.current != null) {
              canvasRef.current
                .getContext("2d")
                .clearRect(0, 0, videoWidth, videoHeight);

              // draw a custom box //
              const box = {
                x: resizedDetections.detection.box.x,
                y: resizedDetections.detection.box.y,
                width: resizedDetections.detection.box.width,
                height: resizedDetections.detection.box.height,
              };
              const drawOptions = {
                lineWidth: 2,
              };

              if ( box.x > 65 && box.x < 170 && box.width > 115 && box.width < 205) {
                glower.className = 'active';
            
                if (cntDetection < 3 && !flag) {
                  setMessage(t("almost_done"));
                }

                if (cntDetection > 2 && cntDetection < 10 && !flag ) {
                  setMessage(t("move_closer"));
                }

                if (cntDetection > 10 && cntDetection < 15 && !flag) {
                  setMessage(t("processing"));
                }

                if (cntDetection > 15 && !flag) {
                  setMessage(t("initializing"));
                }

                // const t0 = performance.now()
                imgSrc.map((assoc) => {
                  const bestMatch = faceMatcher.findBestMatch(assoc[1]);
                  if (bestMatch.label === "Verified" && !flag) {
                    flag = true;
                    captureSnapshot(assoc[0]);
                    setCounter(0);
                    clearInterval(verifyFace);
                    setShowModalFaceVerification(false);
                    handleCloseModalFaceVerification();
                    const Toast = Swal.mixin({
                      toast: true,
                      position: "top-end",
                      showConfirmButton: false,
                      timer: 1800,
                      timerProgressBar: true,
                      didOpen: (toast) => {
                        toast.addEventListener("mouseenter", Swal.stopTimer);
                        toast.addEventListener("mouseleave", Swal.resumeTimer);
                      },
                    });

                    Toast.fire({
                      icon: "success",
                      title: t("face_has_been_recognized"),
                    });

                    setTimeout(() => {
                      checkMySchedule(assoc[0], type);
                    }, 1800);
                  }
                });
                // const t1 = performance.now()
              }
            } else {
              glower.className = 'not-active';
            }
          } else {
            glower.className = 'not-active';
          }
        }
      }

      if (cntDetection > 20 && cancelButtonRef.current && !flag) {
        clearInterval(verifyFace);
        checkNewLandmarks(siteId);
        setShowModalFaceVerification(false);
        handleCloseModalFaceVerification();
        setCounter(0);
        cancelButtonRef.current = true;
        // alert(t("sorry_fail_to_recognize"));
        errorToast.fire({
          icon: "error",
          title: t("sorry_fail_to_recognize"),
        });
      }

      count.current++;
    }, 400);

    setFaceVerificationInterval(verifyFace);
  };

  return (
    <Modal
      ariaHideApp={false}
      isOpen={showModalFaceVerification}
      onRequestClose={handleCloseModalFaceVerification}
      shouldCloseOnOverlayClick={true}
      style={{
        overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
        content: style2,
      }}
    >
      <Logo
        image={ManpowerLogo}
        addedStyles={{
          marginBottom: "5px",
          width: "90px",
          height: "70px",
          position: "absolute",
          left: "22px",
          top: "17px"
        }}
      />
      <CloseButton
        id="btn-cancel"
        title="Close"
        size="sm"
        iconSize={20}
        onClick={() => handleCloseModalFaceVerification()}
        style={{
          position: "absolute",
          top: "2px",
          right: "3px",
        }}
      />
      <div className="d-flex h-100" id="faceid">
        <div className="justify-content-center" style={{paddingTop: "77px"}}>
          <div id="video-container" style={{
              position: "relative",
            }}>
          <video
            id="stream"
            ref={videoRef}
            className="video-facerecog"
            playsInline
            width="540"
            height="400"
            onPlay={handleVideoOnPlay}
            autoPlay
          ></video>
          <canvas
            id="capture"
            ref={canvasRef}
            className="position-absolute"
            style={{
              width:"540",
              height:"400"
            }}
          ></canvas>
          <div className="video-border" 
            style={{
              height: "386px",
              border: "2px solid #6c757d",
              position: "absolute",
              width: "346px",
              top: "8px",
              left: "100px",
              borderRadius: "6%",
            }}>
          </div>
          </div>
        </div>
        <div className="text-center" style={{
          paddingTop: "160px", width: "100%"
        }}>
          {initializing ? (
            <h5>{t("face_verification")}</h5>
          ) : (
            <h4 style={{width: "270px"}}>{message}</h4>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default FaceVerification;
